import { FC } from 'react';
import { Box, useTheme } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import WarningIcon from '@material-ui/icons/Warning';

interface WarningMessageProps {
  message: string;
}

export const WarningMessage: FC<WarningMessageProps> = ({ message }) => {
  const theme = useTheme();
  return (
    <Box
      style={{
        width: '100%',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <WarningIcon
        style={{ color: theme.palette.warning.main, marginRight: '10px' }}
      />
      <Typography variant="body1" style={{ fontWeight: 'bold' }}>
        {message}
      </Typography>
    </Box>
  );
};
